import React, { createContext, useContext, useEffect, ReactNode } from 'react';

// Define available themes
export type ThemeName = 'zap-odeon' | 'zap-dudes';

interface ThemeContextType {
  theme: ThemeName;
}

// Create context with default values
const ThemeContext = createContext<ThemeContextType>({
  theme: 'zap-dudes',
});

// Custom hook to use the theme context
export const useTheme = () => useContext(ThemeContext);

interface ThemeProviderProps {
  children: ReactNode;
}

// Determine theme based on domain
const getThemeFromDomain = (): ThemeName => {
  const hostname = window.location.hostname;
  
  if (hostname.includes('zapodeon.com') || hostname.includes('zapodeon.test')) {
    return 'zap-odeon';
  }
  
  if (hostname.includes('zapdudes.com') || hostname.includes('zapdudes.test')) {
    return 'zap-dudes';
  }
  
  // Default theme for any other domain
  return 'zap-dudes';
};

// Theme provider component
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  // Get theme based on domain
  const theme = getThemeFromDomain();

  // Apply theme class to document element
  useEffect(() => {
    const root = document.documentElement;
    
    // Remove previous theme classes
    root.classList.remove('theme-zap-odeon', 'theme-zap-dudes');
    
    // Add current theme class
    root.classList.add(`theme-${theme}`);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme }}>
      {children}
    </ThemeContext.Provider>
  );
}; 